import { fromLonLat } from 'ol/proj';

import DrawingUtils from '../utils/DrawingUtils';

/**
 * Pilot(조종사) 마커 관리 Feature
 */
class PilotFeature {
  constructor(createOverlay, map) {
    this.createOverlay = createOverlay;
    this.map = map;
    this.pilots = {};
  }

  /**
   * Pilot 마커 추가 또는 업데이트
   * @param {string} robotId - 로봇 ID
   * @param {Object} position - { lat, lng } 좌표
   * @param {string} color - 마커 색상
   */
  addMarker(robotId, position, color) {
    // 기존 Pilot Marker
    if (this.pilots[robotId]) {
      this.pilots[robotId].position = position;
      this.pilots[robotId].marker.setPosition(fromLonLat([position.lng, position.lat]));
    }
    // 신규 Pilot Marker
    else {
      this.pilots[robotId] = {
        position,
        marker: DrawingUtils.drawMarker(this.createOverlay, this.map, position, 'RC', color),
      };
    }
  }

  /**
   * Pilot 마커 제거
   * @param {string} robotId - 로봇 ID
   */
  removeMarker(robotId) {
    if (!this.pilots[robotId]) return;

    this.map.removeOverlay(this.pilots[robotId].marker);
    delete this.pilots[robotId];
  }

  /**
   * Pilot 데이터 가져오기
   * @param {string} robotId - 로봇 ID
   * @returns {Object|undefined} Pilot 데이터
   */
  get(robotId) {
    return this.pilots[robotId];
  }
}

export default PilotFeature;
